import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {connection} from '../../../../../../../ispm-web/shared/modules/bpmn/index';

/**
 * executes the function only if the element is type of @nodeType
 * @param fn
 * @param nodeType
 */
export function ifNodeOfType(fn, nodeType: NodeType) {
  return ifNodeOfTypes(fn, [nodeType]);
}

export function ifNodeOfTypes(fn, nodeTypes: NodeType[]) {
  return function (event) {
    let context = event.context,
      nodeType = context.nodeType;

    if (nodeTypes.includes(nodeType)) {
      fn(event);
    }
  };
}

export function ifNodeOfTypeByNodeDetailes(fn, nodeType: NodeType) {
  return ifNodeOfTypesByNodeDetails(fn, [nodeType]);
}

export function ifNodeOfTypesByNodeDetails(fn, nodeTypes: NodeType[]) {
  return function (event) {
    const element = getElement(event.context);
    const nodeDetails = ModelingUtil.getNodeDetails(element);
    let context = event.context,
      nodeType = nodeDetails ? nodeDetails.nodeType : undefined;

    if (nodeTypes.includes(nodeType)) {
      fn(event);
    }
  };
}

export function isANode(fn) {
  return function (event) {
    const element = getElement(event.context);
    const nodeType = ModelingUtil.getNodeType(element);
    if (nodeType !== null && nodeType !== undefined) {
      fn(event);
    }
  };
}


export function ifElementOfTypes(fn, type) {
  return function (event) {
    let context = event.context,
      shape = getElement(event.context);

    if (type == shape.type) {
      fn(event);
    }
  };
}

export function getElement(context) {
  return context.shape || context.element || context.node || context.newShape;
}

export function isConnection(fn) {
  return function (event) {
    let context = event.context,
      shape = getElement(context)
    if (shape.type === connection) {
      fn(event);
    }
  }
}


